import React, { useMemo } from 'react';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { SetContextLink } from '@apollo/client/link/context';
import { HttpLink } from '@apollo/client/link/http';
import { getApiToken } from './authService';
import { useAuthContext } from './authContext';
import { getApiBaseUrl } from '../config/appConfig';

const ADMIN_GRAPHQL_ENDPOINT = `${getApiBaseUrl()}/graphql-admin`;

console.log('Using Admin GraphQL Endpoint:', ADMIN_GRAPHQL_ENDPOINT);

export default function ApolloProviderWithAdminAuth({ children }) {
  const { msalInstance, account } = useAuthContext();

  const httpLink = useMemo(() => new HttpLink({
    uri: ADMIN_GRAPHQL_ENDPOINT,
  }), []);

  const authLink = useMemo(() =>
    new SetContextLink(async (prevContext, operation) => {
      const token = await getApiToken(msalInstance, account);
      return {
        headers: {
          ...prevContext.headers,
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        }
      };
    }), [msalInstance, account]
  );

  const client = useMemo(() =>
    new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: { errorPolicy: 'all' },
        query: { errorPolicy: 'all' },
      },
    }), [authLink, httpLink]
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}